// import { Icons } from "../../config/MuiIcons.config";
import { ROLES } from "../../config/Roles.config"
// Enabled Icons
import Dashboard_Icon from "../../assets/SidebarMenuIcons/Dashboard.svg"
// import Work_Permit_Icon from "../../assets/SidebarMenuIcons/Work permit.svg"
import Audit_Master_Icon from "../../assets/SidebarMenuIcons/Audit Master.svg"
import Project_Icon from "../../assets/SidebarMenuIcons/Project Master.svg"
import User_Icon from "../../assets/SidebarMenuIcons/User Master.svg"
import Lacation_Icon from "../../assets/SidebarMenuIcons/Location Master.svg"
import Work_Permit_Type_Icon from "../../assets/SidebarMenuIcons/Work Permit Type.svg"
import Work_Permit_Report_Icon from "../../assets/SidebarMenuIcons/Work Permit Report.svg"
import Account_Master_Icon from "../../assets/SidebarMenuIcons/Account Master.svg"
import Area_Master_Icon from "../../assets/SidebarMenuIcons/Area Master.svg"
import Assign_Super_Admin_Icon from "../../assets/SidebarMenuIcons/Assign Super Admin.svg"
import Third_Party_Audit_Icon from "../../assets/SidebarMenuIcons/Third Party Audit.svg"
import Audit_Type_Category_Icon from "../../assets/SidebarMenuIcons/Audit Type Category.svg"

// Disabled Icons
import Dashboard_Icon_White from "../../assets/SidebarMenuIconsWhite/Dashboard_White.svg"
// import Work_Permit_Icon_White from "../../assets/SidebarMenuIconsWhite/Work permit_White.svg"
import Audit_Master_Icon_White from "../../assets/SidebarMenuIconsWhite/Audit Master_White.svg"
import Project_Icon_White from "../../assets/SidebarMenuIconsWhite/Project Master_White.svg"
import User_Icon_White from "../../assets/SidebarMenuIconsWhite/User Master_White.svg"
import Lacation_Icon_White from "../../assets/SidebarMenuIconsWhite/Location Master_White.svg"
import Work_Permit_Type_Icon_White from "../../assets/SidebarMenuIconsWhite/Work Permit Type_White.svg"
import Work_Permit_Report_Icon_White from "../../assets/SidebarMenuIconsWhite/Work Permit Report_White.svg"
import Account_Master_Icon_White from "../../assets/SidebarMenuIconsWhite/Account Master_White.svg"
import Area_Master_Icon_White from "../../assets/SidebarMenuIconsWhite/Area Master_White.svg"
import Assign_Super_Admin_Icon_White from "../../assets/SidebarMenuIconsWhite/Assign Super Admin_White.svg"
import Third_Party_Audit_Icon_White from "../../assets/SidebarMenuIconsWhite/Third Party Audit_White.svg"
import Audit_Type_Category_Icon_White from "../../assets/SidebarMenuIconsWhite/Audit Type Category_White.svg"

export const SidebarRoutes = [
  {
    path: "/",
    icon: (
      <img
        src={Dashboard_Icon}
        alt={"Dashboard"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Dashboard_Icon_White}
        alt={"Dashboard"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Dashboard",
    isNested: false,
    roles: [
      ROLES.SUPERADMIN,
      ROLES.ADMIN,
      ROLES.USER,
    ],
  },
  {
    path: "/audit-master",
    icon: (
      <img
        src={Audit_Master_Icon}
        alt={"Audit Management"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Audit_Master_Icon_White}
        alt={"Audit Management"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Internal Audits",
    isNested: false,
    roles: [
      ROLES.SUPERADMIN,
      ROLES.ADMIN,
      ROLES.USER
    ],
  },
  {
    path: "/third-party-audit-master",
    icon: (
      <img
        src={Third_Party_Audit_Icon}
        alt={"Third Party Audits"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Third_Party_Audit_Icon_White}
        alt={"Third Party Audits"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Third Party Audits",
    isNested: false,
    roles: [
      ROLES.SUPERADMIN,
      ROLES.ADMIN,
      ROLES.USER
    ],
  },
  {
    path: "/",
    icon: (
      <img
        src={Account_Master_Icon}
        alt={"Account Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Account_Master_Icon_White}
        alt={"Account Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Account Master",
    isNested: false,
    roles: [
      ROLES.ZINGWORKS,
    ],
  },
  {
    path: "/assign-super-admin",
    icon: (
      <img
        src={Assign_Super_Admin_Icon}
        alt={"Assign Super Admin"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Assign_Super_Admin_Icon_White}
        alt={"Assign Super Admin"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Assign Super Admin",
    isNested: false,
    roles: [
      ROLES.ZINGWORKS,
    ],
  },
  {
    path: "/user-master",
    icon: (
      <img
        src={User_Icon}
        alt={"User Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={User_Icon_White}
        alt={"User Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "User Master",
    isNested: false,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/branch-master",
    icon: (
      <img
        src={Project_Icon}
        alt={"Branch Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Project_Icon_White}
        alt={"Branch Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Branch Master",
    isNested: false,
    roles: [ROLES.SUPERADMIN],
  },
  {
    path: "/department-master",
    icon: (
      <img
        src={Lacation_Icon}
        alt={"Department Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Lacation_Icon_White}
        alt={"Department Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Department Master",
    isNested: false,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/area-master",
    icon: (
      <img
        src={Area_Master_Icon}
        alt={"Area Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Area_Master_Icon_White}
        alt={"Area Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Area Master",
    isNested: false,
    roles: [
      ROLES.SUPERADMIN,
      ROLES.ADMIN
    ],
  },
  // {
  //   path: "/activity-master",
  //   icon: (
  //     <img
  //       src={Work_Permit_Icon}
  //       alt={"Activity Master"}
  //       style={{height: '24px', width: '24px'}}
  //     />
  //   ),
  //   activeIcon: (
  //     <img
  //       src={Work_Permit_Icon_White}
  //       alt={"Activity Master"}
  //       style={{height: '24px', width: '24px'}}
  //     />
  //   ),
  //   title: "Activity Master",
  //   isNested: false,
  //   roles: [
  //     ROLES.SUPERADMIN,
  //     ROLES.ADMIN
  //   ],
  // },
  {
    path: "/audit-type-category-master",
    icon: (
      <img
        src={Audit_Type_Category_Icon}
        alt={"Audit Type Category"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Audit_Type_Category_Icon_White}
        alt={"Audit Type Category"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Audit Type Category",
    isNested: false,
    roles: [
      ROLES.SUPERADMIN,
      ROLES.ADMIN
    ],
  },
  {
    path: "/audit-type-master",
    icon: (
      <img
        src={Work_Permit_Type_Icon}
        alt={"Audit Type Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Work_Permit_Type_Icon_White}
        alt={"Audit Type Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Audit Type Master",
    isNested: false,
    roles: [
      ROLES.SUPERADMIN,
      ROLES.ADMIN
    ],
  },
  {
    path: "/reports",
    icon: (
      <img
        src={Work_Permit_Report_Icon}
        alt={"Audit Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    activeIcon: (
      <img
        src={Work_Permit_Report_Icon_White}
        alt={"Audit Master"}
        style={{height: '24px', width: '24px'}}
      />
    ),
    title: "Reports",
    isNested: false,
    roles: [
      ROLES.SUPERADMIN,
      ROLES.ADMIN,
      ROLES.USER
    ],
  },
];

export default SidebarRoutes;
